import { Common } from './common';

import * as EhrTimeSlot from './models/ehrTimeSlot';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async cancelBooking(id: string) {
    const url = this.common.constructPath(
      `/patient-previsit/ehr-time-slot-bookings/${id}`,
    );
    return this.common.deleteJSON(url);
  }

  async getBookingInfo(id: string): Promise<EhrTimeSlot.TimeSlotConfirmation> {
    const url = this.common.constructPath(
      `/patient-previsit/ehr-time-slot-bookings/${id}`,
    );
    const { confirmationInformation } = await this.common.getJSON(url);
    return confirmationInformation;
  }
}
